import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';

export const isCashAppSupported = () => {
  return region === Region.US;
};
